// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-back{position:absolute;top:.5rem;left:1rem}`, "",{"version":3,"sources":["webpack://./src/layouts/navigation/navigation.layout.scss"],"names":[],"mappings":"AAAA,UAAU,iBAAiB,CAAC,SAAS,CAAC,SAAS","sourcesContent":[".top-back{position:absolute;top:.5rem;left:1rem}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
